import { readSaved, save } from './storage.js';
// Dark/light theme toggle with localStorage persistence + system-preference fallback
(function () {
    const themeToggle = document.getElementById('theme-toggle');
    const themeIcon = document.getElementById('theme-icon');
    const themeColorMeta = document.getElementById('theme-color-meta');
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    // Keep these in sync with the --bg tokens in css/main.css
    const THEME_COLOR_LIGHT = '#008080';
    const THEME_COLOR_DARK = '#05050f';

    function applyTheme(isDark) {
        document.body.classList.toggle('dark-mode', isDark);
        if (themeIcon) {
            // Show the icon for the mode you'd switch TO
            themeIcon.textContent = isDark ? '☀️' : '🌙';
        }
        if (themeColorMeta) {
            themeColorMeta.setAttribute('content', isDark ? THEME_COLOR_DARK : THEME_COLOR_LIGHT);
        }
        if (themeToggle) themeToggle.setAttribute('aria-pressed', String(isDark));
    }

    function getInitialTheme() {
        const savedTheme = readSaved('theme');
        if (savedTheme === 'dark') return true;
        if (savedTheme === 'light') return false;
        return mediaQuery.matches; // no saved preference → follow the system
    }

    applyTheme(getInitialTheme());

    // Follow system changes only while the user hasn't set a manual preference
    mediaQuery.addEventListener('change', function (e) {
        if (!readSaved('theme')) applyTheme(e.matches);
    });

    if (themeToggle) {
        themeToggle.addEventListener('click', function () {
            const isDark = document.body.classList.contains('dark-mode');
            applyTheme(!isDark);
            save('theme', isDark ? 'light' : 'dark');
        });
    }
})();
